// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--bkxSR","description":"a10a3f92e9--description--24vWY","link":"a10a3f92e9--link--PKA8E","icon_wrapper":"a10a3f92e9--icon_wrapper--t9PZq"};